import { useISLRContext } from '../context/ISLRContext';
import { useAlert } from '../context/AlertContext';

/**
 * Hook personalizado para manejar la lógica de retenciones ISLR
 * Wrapper sobre ISLRContext para compatibilidad y acceso global
 */
export const useISLR = () => {
    const context = useISLRContext();
    const { showAlert } = useAlert();

    // Envolver funciones del contexto que necesiten manejo de UI adicional (Alertas)
    // para mantener comportamiento exacto del hook original si es necesario.
    // Aunque el contexto ya lanza errores, aquí podemos capturarlos y mostrar toast si queremos mantener esa lógica del hook original.

    const createRetencionWrapper = async (data) => {
        try {
            return await context.createRetencion(data);
        } catch (err) {
            showAlert({
                title: 'Error',
                message: err.message || 'No se pudo crear la retención',
                variant: 'danger'
            });
            return false;
        }
    };

    const deleteRetencionWrapper = async (id) => {
        try {
            return await context.deleteRetencion(id);
        } catch (err) {
            showAlert({
                title: 'Error',
                message: err.message || 'No se pudo eliminar la retención',
                variant: 'danger'
            });
            return false;
        }
    };

    const getComprobantePdfWrapper = async (id) => {
        try {
            return await context.getComprobantePdf(id);
        } catch (err) {
            showAlert({
                title: 'Error',
                message: 'No se pudo descargar el comprobante PDF',
                variant: 'danger'
            });
            throw err;
        }
    };

    return {
        ...context,
        createRetencion: createRetencionWrapper,
        deleteRetencion: deleteRetencionWrapper,
        getComprobantePdf: getComprobantePdfWrapper
    };
};

